import React, { useEffect, useState } from "react";
import Button from "../../extra/Button";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import Input from "../../extra/Input";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  createSlider,
  updateSlider,
} from "../../store/slider/slider.action";

const SliderDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const [mongoId, setMongoId] = useState(0);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [order, setOrder] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [image, setImage] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [error, setError] = useState({
    image: "",
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setMongoId(dialogueData?._id);
    setTitle(dialogueData?.title || "");
    setSubtitle(dialogueData?.subtitle || "");
    setOrder(dialogueData?.order || 0);
    setIsActive(dialogueData?.isActive !== undefined ? dialogueData?.isActive : true);
    setImagePath(dialogueData?.image);
  }, [dialogueData]);

  const handleImage = (e) => {
    setError((prevErrors) => ({
      ...prevErrors,
      image: "",
    }));
    setImage(e.target.files[0]);
    setImagePath(URL.createObjectURL(e.target.files[0]));
  };

  const handleSubmit = () => {
    if (!imagePath) {
      return setError({ image: "Image is required!" });
    } else {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("subtitle", subtitle);
      formData.append("order", order);
      formData.append("isActive", isActive);
      if (image) {
        formData.append("image", image);
      }

      if (mongoId) {
        dispatch(updateSlider(formData, mongoId));
      } else {
        dispatch(createSlider(formData));
      }
      dispatch({ type: CLOSE_DIALOGUE });
    }
  };

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue">
        <div className="dialogueHeader">
          <div className="headerTitle fw-bold text-white">Slider</div>
          <div
            className="closeBtn "
            onClick={() => {
              dispatch({ type: CLOSE_DIALOGUE });
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>
        <div className="dialogueMain">
          <div className="row">
            <div className="col-12">
              <Input
                label={`Image`}
                id={`image`}
                type={`file`}
                accept={`image/*`}
                errorMessage={error.image && error.image}
                onChange={(e) => handleImage(e)}
              />
              {imagePath && (
                <div className="image-start">
                  <img
                    src={imagePath}
                    alt="slider"
                    draggable="false"
                    width={200}
                    className="m-0"
                    style={{ borderRadius: "8px" }}
                  />
                </div>
              )}
            </div>
            <div className="col-12">
              <Input
                label={`Title (Optional)`}
                id={`title`}
                type={`text`}
                value={title}
                placeholder={`Enter title`}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="col-12">
              <Input
                label={`Subtitle (Optional)`}
                id={`subtitle`}
                type={`text`}
                value={subtitle}
                placeholder={`Enter subtitle`}
                onChange={(e) => setSubtitle(e.target.value)}
              />
            </div>
            <div className="col-12">
              <Input
                label={`Order`}
                id={`order`}
                type={`number`}
                value={order}
                placeholder={`Enter order number`}
                onChange={(e) => setOrder(parseInt(e.target.value) || 0)}
              />
            </div>
            <div className="col-12">
              <div className="form-check" style={{ marginTop: "10px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isActive"
                  checked={isActive}
                  onChange={(e) => setIsActive(e.target.checked)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  className="form-check-label text-white"
                  htmlFor="isActive"
                  style={{ cursor: "pointer" }}
                >
                  Active
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="dialogueFooter">
          <div className="dialogueBtn">
            {!mongoId ? (
              <>
                <Button
                  btnName={`Submit`}
                  btnColor={`btnBlackPrime text-light`}
                  style={{ borderRadius: "5px", width: "80px" }}
                  newClass={`me-2`}
                  onClick={handleSubmit}
                />
              </>
            ) : (
              <>
                <Button
                  btnName={`Update`}
                  btnColor={`btnBlackPrime text-light`}
                  style={{ borderRadius: "5px", width: "80px" }}
                  newClass={`me-2`}
                  onClick={handleSubmit}
                />
              </>
            )}
            <Button
              btnName={`Close`}
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => {
                dispatch({ type: CLOSE_DIALOGUE });
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createSlider, updateSlider })(
  SliderDialog
);
